import { Component } from '@angular/core';
import { ColumnCheckboxDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-checkbox',
  templateUrl: './ap-column-checkbox.component.html',
})
export class ApColumnCheckboxComponent extends ApColumnBase<ColumnCheckboxDto> {
  load() {
    return;
  }

  onChange() {
    this.columnInfoDto.OnChangeCallback(this.dataItem);
  }
}
